import { Card, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const CashFlowChart = ({ theme, data, compact = false }) => (
  <Card
    sx={{
      p: { xs: 1.25, sm: 2 },
      borderRadius: 2.5,
      border: "1px solid",
      borderColor: "divider",
      boxShadow: "0 6px 16px rgba(15,23,42,0.08)",
      minWidth: 0,
    }}
  >
    <Typography variant={compact ? "subtitle1" : "h6"} fontWeight={800}>
      Cash Flow
    </Typography>
    <ResponsiveContainer width="100%" height={compact ? 220 : 350}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="fecha" hide />
        <YAxis />
        <Tooltip />
        <Legend verticalAlign="bottom" height={36} />
        <Line
          type="monotone"
          dataKey="cashFlowDia"
          stroke={theme.palette.error.main}
          strokeWidth={1.5}
          dot={false}
          name="CF Día"
        />
        <Line
          type="monotone"
          dataKey="cashFlowAcum"
          stroke={theme.palette.primary.main}
          strokeWidth={2.5}
          dot={false}
          name="CF Acumulado"
        />
      </LineChart>
    </ResponsiveContainer>
  </Card>
);

export default CashFlowChart;
